import { createRoot } from "react-dom/client"
import { App } from "./App"
import { applyConfigToDocument } from "./config/branding"
import { loadAppConfig } from "./config/loader"
import "./styles/global.css"

async function bootstrap() {
  const loaded = await loadAppConfig()
  applyConfigToDocument(loaded.config)

  for (const warning of loaded.warnings) {
    if (import.meta.env.DEV) console.warn(`[config] ${warning}`)
  }

  const container = document.getElementById("root")
  if (!container) throw new Error("#root is missing")
  createRoot(container).render(<App loaded={loaded} />)
}

void bootstrap().catch((error: unknown) => {
  console.error("[jumble] failed to start", error)
  const container = document.getElementById("root")
  if (container) {
    container.innerHTML = `<div style="padding:24px;font-family:system-ui;color:#c04">
      <h1>The client could not start</h1>
      <pre>${error instanceof Error ? error.message : String(error)}</pre>
    </div>`
  }
})
